<!--
 * @Descripttion: JtForm V2 版本
 * @version:
 * @Author: hongye
 * @Date: 2026-06-15
 * @LastEditors: 'yanghongye'
 * @LastEditTime: 2026-07-15 19:27:10
-->
<template>
  <Form ref="formRef" class="jt-form" :model="searchParam" @finish="onFinish" v-bind="$attrs">
    <div class="btn-box" v-if="position === 'leftTop'">
      <div class="btn-left">
        <slot name="preBtn"></slot>
        <Button type="primary" :loading="loading" html-type="submit">
          <template #icon>
            <slot name="searchIcon">
              <SearchOutlined />
            </slot>
          </template>
          {{ $lang('查询') }}
        </Button>
        <Button style="margin-left: 8px" html-type="submit" @click="() => reset()" :loading="loading">
          <template #icon>
            <slot name="resetIcon">
              <RedoOutlined />
            </slot>
          </template>
          {{ $lang('重置') }}
        </Button>
        <slot name="nextBtn"></slot>
      </div>
      <div>
        <span v-if="enabledExpand" class="expand-box" @click="toggleExpand">
          <template v-if="expandValue">
            <UpOutlined />
            <span class="expand-desc">{{ $lang('收起') }}</span>
          </template>
          <template v-else>
            <DownOutlined />
            <span class="expand-desc">{{ $lang('展开') }}</span>
          </template>
        </span>
      </div>
    </div>
    <Row v-bind="{ ...rowProps }">
      <Col
        v-show="enabledExpand ? expandValue || index < expandIndex : true"
        v-bind="{ ...(item.colProps || gridAttr) }"
        v-for="(item, index) in columns.filter((_) => !_.hideItem)"
        :key="index"
      >
        <FormItem
          :rules="item.rules"
          :colon="false"
          validateFirst
          v-bind="{ ...item.formItem }"
          :name="item.prop"
        >
          <template #label>
            <slot v-if="item.labelSlot" :name="`${item.prop}Label`" :searchParam="searchParam" :item="item"></slot>
            <template v-else> {{ item.label ? `${$lang(item.label)}` : undefined }}</template>
          </template>
          <slot v-if="item.slot" :name="item.slot" :item="item"></slot>
          <component
            v-else-if="item.component"
            :searchParam="searchParam"
            v-model:value="searchParam[item.prop]"
            :item="item"
            v-bind="{ ...item }"
            :is="item.component"
          ></component>
          <template v-else>
            <Input
              v-if="item.searchType === 'textarea'"
              v-model:value="searchParam[item.prop]"
              v-bind="item"
              :placeholder="getPlaceholder(item)"
            />
            <Select
              v-else-if="item.searchType === 'select'"
              v-model:value="searchParam[item.prop]"
              v-bind="item"
              :placeholder="getPlaceholder(item)"
            />
            <DatePicker
              v-else-if="item.searchType === 'date'"
              v-model:value="searchParam[item.prop]"
              v-bind="item"
            />
            <Cascader
              v-else-if="item.searchType === 'cascader'"
              v-model:value="searchParam[item.prop]"
              v-bind="item"
            />
            <RangePicker
              v-else-if="item.searchType === 'datetimerange'"
              v-model:value="searchParam[item.prop]"
              v-bind="item"
              @change="(...args) => handleRangeChange(item, args)"
            />
            <Input
              v-else
              v-model:value="searchParam[item.prop]"
              v-bind="item"
              :placeholder="getPlaceholder(item)"
            />
          </template>
        </FormItem>
      </Col>
      <Col id="search-btns" v-bind="{ ...gridAttr }" style="flex: inherit; max-width: 100%;" v-if="position === 'bottom'">
        <FormItem v-if="!$slots.btns" :label="columns[0]?.label && !isLeft ? ' ' : null">
          <slot name="preBtn"></slot>
          <Button type="primary" :loading="loading" html-type="submit">
            <template #icon>
              <slot name="searchIcon">
                <SearchOutlined />
              </slot>
            </template>
            {{ $lang('查询') }}
          </Button>
          <Button style="margin-left: 8px" html-type="submit" @click="() => reset()" :loading="loading">
            <template #icon>
              <slot name="resetIcon">
                <RedoOutlined />
              </slot>
            </template>
            {{ $lang('重置') }}
          </Button>
          <slot name="nextBtn"></slot>
          &nbsp;
          <span v-if="enabledExpand" class="expand-box" @click="toggleExpand">
            <template v-if="expandValue">
              <UpOutlined />
              <span class="expand-desc">{{ $lang('收起') }}</span>
            </template>
            <template v-else>
              <DownOutlined />
              <span class="expand-desc">{{ $lang('展开') }}</span>
            </template>
          </span>
        </FormItem>
        <FormItem v-else :label="columns[0]?.label && !isLeft ? ' ' : null">
          <slot name="btns"></slot>
          &nbsp;
          <span v-if="enabledExpand" class="expand-box" @click="toggleExpand">
            <template v-if="expandValue">
              <UpOutlined />
              <span class="expand-desc">{{ $lang('收起') }}</span>
            </template>
            <template v-else>
              <DownOutlined />
              <span class="expand-desc">{{ $lang('展开') }}</span>
            </template>
          </span>
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script lang="ts">
  import { ref, computed, defineComponent, PropType, onMounted, getCurrentInstance } from 'vue'
  import {
    Row,
    Col,
    Form,
    FormItem,
    Button,
    Input,
    Select,
    DatePicker,
    RangePicker,
    Cascader
  } from 'ant-design-vue'
  import { DownOutlined, UpOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons-vue'
  import type { FormInstance } from 'ant-design-vue'
  import { debounce } from 'lodash-es'
  import type { FormListItem } from '@xinghai/site-common'
  import { triggerGlobalResize } from '@/hooks/useGlobalResize'

  export default defineComponent({
    name: 'JtFormV2',
    components: {
      Row,
      Col,
      Form,
      FormItem,
      Button,
      Input,
      Select,
      DatePicker,
      RangePicker,
      Cascader,
      DownOutlined,
      UpOutlined,
      SearchOutlined,
      RedoOutlined
    },
    inheritAttrs: false,
    props: {
      columns: { type: Array as PropType<Partial<FormListItem>[]>, default: () => [] },
      searchParam: { type: Object as PropType<Record<string, any>>, default: () => ({}) },
      loading: Boolean,
      expandIndex: { type: Number, default: 8 },
      gridAttr: {
        type: Object as PropType<Partial<Record<string, number>>>,
        default: () => ({ xs: 24, sm: 12, md: 12, lg: 8, xl: 6, xxl: 6, xxxl: 4 })
      },
      rowProps: {
        type: Object,
        default: () => ({ gutter: 24 })
      },
      /** 是否启用折叠功能，默认不启用 */
      enabledExpand: { type: Boolean, default: false },
      position: { type: String, default: 'bottom' },
      /** 展开/收起状态，支持双向绑定 */
      expand: { type: Boolean, default: undefined },
      /** 默认展开状态，仅在未传入 expand 时生效 */
      defaultExpand: { type: Boolean, default: false }
    },
    emits: ['search', 'update:searchParam', 'resetField', 'update:expand', 'expandChange'],
    setup(props, { emit, slots }) {
      const instance = getCurrentInstance()
      const $lang = instance?.proxy?.$lang

      /** 内部维护的展开状态，当未传入 expand 时使用 */
      const internalExpand = ref(props.expand !== undefined ? props.expand : props.defaultExpand)

      /** 展开/收起计算属性，支持外部 v-model:expand 双向绑定 */
      const expandValue = computed({
        get: () => (props.expand !== undefined ? props.expand : internalExpand.value),
        set: (val) => {
          if (props.expand !== undefined) {
            emit('update:expand', val)
          }
          internalExpand.value = val
        }
      })

      /** 切换展开/收起 */
      const toggleExpand = () => {
        expandValue.value = !expandValue.value
        emit('expandChange', expandValue.value)
        handleResize()
        // 触发全局 resize 回调，供下游组件（如 JtTable）重新计算 scroll.y
        triggerGlobalResize()
      }

      const formRef = ref<FormInstance>()

      const onFinish = (values: any) => {
        emit('search')
      }

      const reset = () => {
        formRef.value?.resetFields()
        emit('resetField')
      }

      /** 查询按钮是否最左边 */
      const isLeft = ref(false)
      const handleResize = debounce(() => {
        const btnXdistance = document.querySelector('#search-btns')?.getBoundingClientRect().left as number
        // 作为在最左边的依据
        isLeft.value = btnXdistance <= 230
      }, 100)

      onMounted(() => {
        handleResize()
        window.addEventListener('resize', handleResize)
      })

      /** 获取表单项 placeholder */
      const getPlaceholder = (item: Partial<FormListItem>) => {
        if (item.placeholder) {
          return $lang?.(item.placeholder) || item.placeholder
        }
        if (item.label) {
          const prefix =
            item.searchType === 'select'
              ? $lang?.('请选择') || '请选择'
              : $lang?.('请输入') || '请输入'
          return `${prefix}${item.label}`
        }
        return ''
      }

      /** 日期范围选择变更，处理真实字段映射 */
      const handleRangeChange = (item: Partial<FormListItem>, args: any[]) => {
        const [e, val] = args
        if (item.realField && Array.isArray(val)) {
          item.realField.forEach((field, i) => {
            props.searchParam[field] = val[i]
          })
        }
      }

      return {
        formRef,
        onFinish,
        reset,
        expandValue,
        toggleExpand,
        isLeft,
        slots,
        getPlaceholder,
        handleRangeChange
      }
    }
  })
</script>

<style lang="less">
  .jt-form {
    background-color: #fff;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    margin-bottom: 10px;
    .btn-left {
      width: 80%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .expand-box {
    &:hover {
      cursor: pointer;
    }
    .expand-desc {
      margin-left: 5px;
    }
  }
</style>
